import React, { Component } from "react";
import "./index.scss";
import { connect } from "react-redux";
import { storeChangeObject, storeMenuType } from "@action";
class Choices extends Component {
  render() {
    const { props } = this;
    return props.videoData && props.videoData.choices ? (
      <div
        className={`choices_box animated ${
          props.showChoices == 1 ? "fadeInUp" : ""
        } ${props.showChoices == 2 ? "fadeOutDown" : ""} ${
          !props.showChoices ? "dis_n" : ""
        }`}
      >
        {/* <div
          className={`${
            !props.choicesResult && props.showChoices == 1 ? "choices_line" : ""
          }`}
        ></div> */}
        <div className="question">{props.videoData.choices.choicesTxt}</div>
        <div className="choice-ctnr dis_f ali_ct jus_ct poa">
          {props.videoData.choices.choicesArr.map((item, index) => (
            <div
              key={index}
              className={`choice_btn poa left animated${
                props.choicesResult == index + 1 &&
                props.videoData.choices.choicesArr.length != 1
                  ? " fadeIn active"
                  : ""
              } ${
                props.choicesResult && props.choicesResult != index + 1
                  ? " fadeOutDown"
                  : ""
              } ${
                props.videoData.choices.choicesArr.length == 1 ? "one_item" : ""
              }`}
              onClick={() => props.onSelectChoices(index + 1)}
            >
              {item.choicesBtn}
            </div>
          ))}
        </div>
      </div>
    ) : null;
  }
}
const mapStateToProps = state => {
  return {
    ...state,
    choicesResult: state.showChoices
      ? state.choicesArr[state.choicesArr.length - 1].tag
      : 0
  };
};
export default connect(mapStateToProps, null)(Choices);
